import Reveal, { Eyebrow } from "./Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";

const FAQS = [
  { q: "Does Voicxent replace our people?", a: "No. It replaces the dialling and the first conversation at scale. Humans work the queue: escalations, approvals, and anything the agent cannot resolve." },
  { q: "Can the agent transfer a live call to a human?", a: "No. If a customer asks for a human, or the agent cannot proceed, the case is flagged for human follow-up with the reason recorded. There is no live transfer." },
  { q: "Is Voicxent only for collections?", a: "No. Collections is one pack on the platform. The same platform runs a clinic receptionist, garage reminders, pharmacy calls, and restaurant orders — configured per business." },
  { q: "Who can see our customer data?", a: "Only your tenant. Each tenant has its own database, and platform admins cannot see tenant customer data." },
  { q: "Which languages does it speak?", a: "Hindi, English and Bengali." },
  { q: "What do we get back after a campaign?", a: "Dispositions, full transcripts, recordings and captured fields for every call, plus an export in the same shape as your files." },
  { q: "What does it cost?", a: "Contact us for pricing — no prices are published on this website. The fastest way is a demo followed by a pilot on one use case, measured against your current results." },
];

const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-20 sm:py-28 bg-white border-y border-zinc-200">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <Eyebrow>FAQ</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]">
              Straight answers.
            </h2>
            <p className="text-zinc-600 mt-6 leading-relaxed max-w-sm">
              The questions every operations lead asks before a pilot — answered the same way we
              answer them on a call.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-accordion-item-${i + 1}`}>
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i + 1}`}
                    className="font-display font-bold text-base sm:text-lg text-left hover:no-underline hover:text-[#2563EB] transition-colors duration-300 py-5"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-zinc-600 text-sm sm:text-base leading-relaxed pb-6 max-w-2xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Faq;
